import Vue from 'vue';

import ArticleListStatic from '../components/article/ArticleListStatic.vue';
import GigListStatic from '../components/gig/GigListStatic.vue';

document.addEventListener('DOMContentLoaded', () => {
  const gigsData = document.querySelector('gig-list-static').dataset;

  (() => new Vue({
    el: 'gig-list-static',
    render: h => h(GigListStatic, {
      props: {
        gigs: JSON.parse(gigsData.gigs),
      },
    }),
  }))();

  const articlesData = document.querySelector('article-list-static').dataset;

  (() => new Vue({
    el: 'article-list-static',
    render: h => h(ArticleListStatic, {
      props: {
        articles: JSON.parse(articlesData.articles),
      },
    }),
  }))();
});
